import {observable, action, makeObservable} from 'mobx';
import {pricing} from './api';
import {ProductUI, StoreInfo, ViewProduct, ProductState, GlassPrices, ViewGlass, ProductStateShare} from './i';
import {ProductCustomizationState} from './rendering/render.def';
import {r} from './rendering/core';
import {prerender_set_pcs} from './rendering/web-only-render';
import {updateShippingBoxID} from './calc';
import {toJS} from 'mobx';
import {RenderV2Object} from '../renderV2/frame-builder/render-v2-d';
import {currency_noNegatives, debounce, getParameterByName, isNullOrWhiteSpace, modal, Portal, RenderType} from '../util';

declare var __isMyFrames: boolean;
declare var __StoreID: number;
declare var __preload_product: string;
declare var __preload_glass_prices: string;
declare var __fast_ship: boolean;
declare var klaviyo: any[];
declare const window: any;
declare const marketing_product_visit: (arg: any[]) => void;
declare var __company_name: string;
declare var __domain_name: string;
declare var __oversized: number[];

export class ProdStore {
    @observable ui: ProductUI;
    @observable ps: ProductState;
    @observable pcs: ProductCustomizationState;
    @observable prod: ViewProduct;
    @observable si: StoreInfo;
    @observable isRetail: boolean;
    @observable debug: boolean = true;
    @observable errorLog: string;
    @observable errorLogInfo: string;
    @observable apiError: boolean = false;
    @observable ready: boolean = false;
    @observable __fast_ship_orig: boolean = false;
    @observable __fast_ship_warned: boolean = false;
    @observable selected_doc_size: number = 3;
    @observable glass_prices: GlassPrices[];
    @observable glass: ViewGlass[];
    @observable ppi_w: number;
    @observable ppi_h: number;
    @observable ppi_w_max: number;
    @observable ppi_h_max: number;
    @observable ppi_w_actual: number;
    @observable ppi_h_actual: number;
    @observable product_thumbnail_height: number = 75;
    @observable IsPortal3: boolean = false;
    @observable currentGradSchoolID: number = -1;
    @observable hasDYFLinoNonProduct: boolean = false;
    @observable hasSomeProductLino: boolean = false;
    @observable RenderingV2: boolean = false;
    @observable frameV2: RenderV2Object;

    constructor() {
        this.ui = {
            product_title: '',
            item_id: '',
            sku: '',
            msrp: 0,
            price: 0,
            price_discount: 0,
            review_count: 0,
            review_score: 5,
            doc_type: '',
            box_id: -1,
            categoryIds: [],

            show_grad_year: true,
            show_atc: true,
            show_cust: true,
            show_pricing: true,

            name_moulding: '',
            moulding_has_zoom: true,
            moulding_zoom_path: '',
            moulding_zoom_path_th: '',

            name_mat1: '',
            name_mat2: '',
            name_glass: '',
            name_insignia: '',

            title_mat_combo: '',
            title_moulding: '',
            title_mat1: '',
            title_mat2: '',
            title_glass: '',
            title_insignia: '',
            title_vlbg: '',

            color_mat1: '',
            color_mat2: '',
            old_style_composite: '',

            linen: false,

            doRender: false,
            update_pricing: false,
            update_doc_sizes: false,

            zoom_thumbnails: false,
            zoom_real_images: false,
            show_caf_doc_sizes: false,
            show_caf_doc_sizes_both: false,

            bo_msg: '',
            is_bo: false,

            moulding_th5: false,
            moulding_th6: false,

            image_uploaded: false,
            image_uploaded_msg: '',
            image_uploading: false,
            image_upload_error: false,
            processing_title: '',
            processing_text: '',
            allow_customer_photos: true,
            allow_reviews: true,
            allow_smartbox: true,
        };

        this.glass = [
            {id: 1, title: 'Standard', price: '$0'},
            {id: 2, title: 'Reflection Control', price: '$0'},
            {id: 3, title: 'Conservation UV', price: '$0'},
            {id: 4, title: 'UV & Reflection Control', price: '$0'},
        ];

        this.ps = {} as ProductState;
        makeObservable(this);
    }

    @action
    init = () => {
        this.IsPortal3 = Portal?.PortalID === 3;
        this.__fast_ship_orig = __fast_ship;
        this.isRetail = !__isMyFrames;
        this.prod = JSON.parse(JSON.stringify(__preload_product)) as ViewProduct;
        this.glass_prices = JSON.parse(JSON.stringify(__preload_glass_prices)) as GlassPrices[];
        this.si = this.prod.StoreInfo[__StoreID];
        this.currentGradSchoolID = this.si.GradSchoolID;

        if (this.prod.ProductID === 51558) {
            __fast_ship = true;
            this.__fast_ship_orig = true;
        }

        if (this.prod.mouldings) {
            this.prod.mouldings = this.prod.mouldings.filter(x => x.storeId == __StoreID);
            this.prod.mouldings.map((m, i) => (m.i = i));

            const _fm = this.prod.mouldings.filter(x => x.id === this.prod.MouldingID);
            if (_fm && _fm.length > 0) {
                s.ui.moulding_th5 = _fm[0].th5;
                s.ui.moulding_th6 = _fm[0].th6;
            }
        } else {
            s.prod.mouldings = [];
        }
        if (this.prod.mats) {
            this.prod.mats = this.prod.mats.filter(x => x.storeId == __StoreID);
            this.prod.mats.map((m, i) => (m.i = i));
        } else {
            s.prod.mats = [];
        }
        if (this.prod.caf_mat1) {
            this.prod.caf_mat1 = this.prod.caf_mat1.filter(x => x.storeId == __StoreID);
            this.prod.caf_mat1.filter(x => x.storeId == __StoreID).map((m, i) => (m.i = i));
        } else {
            s.prod.caf_mat1 = [];
        }
        if (this.prod.caf_mat2) {
            this.prod.caf_mat2 = this.prod.caf_mat2.filter(x => x.storeId == __StoreID);
            this.prod.caf_mat2.filter(x => x.storeId == __StoreID).map((m, i) => (m.i = i));
        } else {
            s.prod.caf_mat2 = [];
        }
        if (this.prod.insignias) {
            this.prod.insignias = this.prod.insignias.filter(x => x.storeId == __StoreID);
            this.prod.insignias.filter(x => x.storeId == __StoreID).map((m, i) => (m.i = i));
        } else {
            s.prod.insignias = [];
        }
        if (this.prod.linos) {
            this.prod.linos = this.prod.linos.filter(x => x.storeId == __StoreID);
            this.prod.linos.map((m, i) => (m.i = i));

            var _checkTest = this.prod.linos.filter(x => x.dyf_custom_lino_type_id > 0);
            var _checkTestNonDYF = this.prod.linos.filter(x => x.dyf_custom_lino_type_id < 1);
            s.hasDYFLinoNonProduct = _checkTest && _checkTest.length > 0;
            s.hasSomeProductLino = _checkTestNonDYF && _checkTestNonDYF.length > 0;

            if (!this.prod.IsCAF) {
                if (__isMyFrames && this.prod.LinoID > 0) {
                    this.prod.linos = this.prod.linos.filter(x => x.id == this.prod.LinoID);
                } else if ((!this.prod.LinoID || this.prod.LinoID < 1) && !s.hasDYFLinoNonProduct) {
                    s.prod.linos = [];
                }
            }
        } else {
            s.prod.linos = [];
        }
        if (s.prod.CustomizationMethod === 2 && !s.prod.IsCAF) {
            let _hit = false;
            if (this.si.DocumentID > 0) {
                _hit = true;
                s.prod.DocumentID = this.si.DocumentID;
                s.prod.orig_pcs.DocumentID = this.si.DocumentID;
                s.prod.DocumentName = this.si.DocumentName;
                s.prod.DocumentDisplayName = this.si.DocumentDisplayName;
                s.prod.orig_pcs.Base_DocumentName = this.si.DocumentName;
            }
            if (this.si.DocumentID2 > 0) {
                _hit = true;
                s.prod.DocumentID2 = this.si.DocumentID2;
                s.prod.orig_pcs.DocumentID2 = this.si.DocumentID2;
                s.prod.DocumentName2 = this.si.DocumentName2;
                s.prod.DocumentDisplayName2 = this.si.DocumentDisplayName2;
                s.prod.orig_pcs.Base_DocumentName2 = this.si.DocumentName2;
            }

            if (_hit) {
                if (!isNullOrWhiteSpace(this.si.th_auto_2_1)) {
                    s.prod.th_auto_2_1 = this.si.th_auto_2_1;
                    s.prod.th6_special = true;
                }
                if (!isNullOrWhiteSpace(this.si.th_auto_2_2)) {
                    s.prod.th_auto_2_2 = this.si.th_auto_2_2;
                    s.prod.th5_special = true;
                }
                if (!isNullOrWhiteSpace(this.si.th_auto_2_16)) {
                    s.prod.th_auto_2_16 = this.si.th_auto_2_16;
                }
                if (!isNullOrWhiteSpace(this.si.th_auto_2_17)) {
                    s.prod.th_auto_2_17 = this.si.th_auto_2_17;
                }
            }
        }

        // setup ui
        this.ui.item_id = this.prod.ItemID;
        this.ui.price = this.isRetail ? this.si.Price_Retail : this.si.Price_Wholesale;
        this.prod.reviewCount;
        this.prod.reviewScore;
        this.ui.msrp = this.si.priceMSRPDec;
        this.ui.product_title = this.prod.Name;
        this.ui.doc_type = this.prod.DocType;
        this.ui.box_id = this.prod.Shipping_BoxID;
        const cat = [...new Set(this.prod.categories.map(m => m.CategoryID))];
        for (let i = 0; i < cat.length; i++) {
            if (s.prod.categories.filter(x => x.CategoryID === cat[i]).length > 1) {
                this.ui.categoryIds.push(cat[i]);
            }
        }
        if (this.si.StoreTypeID === 5 && this.isRetail) {
            this.ui.show_grad_year = false;
        }
        if (this.si.StoreTypeID === 5 && this.isRetail) {
            this.ui.show_cust = false;
        }

        if (this.prod.ForcePlexiglass) {
            this.ps.use_plexi = true;
        }
        this.ps.is_caf = this.prod.IsCAF;
        this.prod.orig_pcs.IsCAF = this.prod.IsCAF;
        this.ps.customized_core = false;
        this.ps.customized_glass = false;
        this.ps.base_product_id = this.prod.ProductID;
        this.ps.base_item_id = this.prod.ItemID;
        this.ps.docWidth = this.prod.docWidth;
        this.ps.docHeight = this.prod.docHeight;
        this.ps.docWidth2 = this.prod.docWidth2;
        this.ps.docHeight2 = this.prod.docHeight2;
        this.ps.moulding_id = this.prod.MouldingID;
        this.ps.moulding_extWidth = this.prod.MouldingExtWidth;
        this.ui.moulding_has_zoom = this.prod.MouldingHasZoom;
        this.ui.moulding_zoom_path = this.prod.Moulding_IMG_Zoom;
        this.ui.moulding_zoom_path_th = this.prod.Moulding_IMG_ZoomThumb;
        this.ps.matcombo_id = this.prod.MatComboID;
        this.ps.mat1_id = this.prod.Mat1_ID;
        this.ps.mat2_id = this.prod.Mat2_ID;
        this.ps.insignia_id = this.prod.InsigniaID;
        this.ps.insignia_base_name = this.prod.InsigniaName;
        this.ui.name_insignia = this.prod.InsigniaName ? this.prod.InsigniaName.toLowerCase() : '';
        this.ps.glass_id = 1;
        this.ps.ep_id = 0;
        this.ps.ep_id_view = 37;
        this.ps.wholesale = __isMyFrames;
        this.ps.qty = 1;
        this.ui.review_count = this.prod.reviewCount;
        this.ui.review_score = this.prod.reviewScore;
        if (!this.ps.is_caf) {
            this.ps.item_id = this.prod.orig_pcs.ItemID;
        } else {
            s.ui.moulding_has_zoom = true;
        }
        this.ps.category_map_id = this.prod.orig_pcs.SelectedCategoryMapID;
        if (this.prod.EngravedPlateStatusID === 1) {
            this.ps.ep_id = 37;
        } else if (this.prod.EngravedPlateStatusID === 2) {
            this.ps.ep_id = 39;
            this.ps.ep_id_view = 39;
        } else if (this.prod.EngravedPlateStatusID === 4) {
            this.ps.ep_id_view = 39;
        } else if (this.prod.EngravedPlateStatusID === 6) {
            this.ps.ep_id = 1099;
        } else if (this.prod.EngravedPlateStatusID === 7) {
            this.ps.ep_id = 1099;
            this.ps.ep_id_view = 1099;
        } else if (this.prod.EngravedPlateStatusID === 8) {
            this.ps.ep_id = 33146;
        } else if (this.prod.EngravedPlateStatusID === 9) {
            this.ps.ep_id = 33146;
            this.ps.ep_id_view = 33146;
        }

        this.ps.lino_id = this.prod.LinoID;
        this.ps.lino_base_name = this.prod.orig_pcs.Base_LinoName;
        this.ps.lino_dyf_color = 'gold';
        this.ps.lino_is_dyf = this.prod.ProductID < 0;
        this.ps.is_horizontal = this.prod.IsHorizontal;
        this.ps.ProductTypeID = this.prod.ProductTypeID;

        const ep_type = getParameterByName('ep_type');

        if (ep_type) {
            s.prod.EPMethodID = parseInt(ep_type, 10);
        }

        const ep_border = getParameterByName('ep_border');

        if (ep_border) {
            s.prod.EPBorderType = parseInt(ep_border, 10);
        }

        if (this.prod.DYF_FrameStyleID === 4) {
            this.ps.vlbg_id = this.prod.VLBG_ID;
            const vlbg = s.prod.caf_mat2.filter(x => x.id === this.ps.vlbg_id)[0];
            if (vlbg) {
                this.ps.vlbg_color = vlbg.mat_color;
                this.ui.title_vlbg = vlbg.title;
            }
        }

        if (this.ps.is_caf) {
            this.ui.update_pricing = true;
            var _m = this.prod.mouldings.filter(x => x.isBase);
            if (_m.length > 0) {
                this.ps.moulding_id = _m[0].id;
            }
            var _i = this.prod.insignias.filter(x => x.isBase);
            if (_i.length > 0) {
                this.ps.insignia_id = _i[0].id;
            }
            var _l = this.prod.linos.filter(x => x.isBase);
            if (_l.length > 0) {
                this.ps.lino_id = _l[0].id;
            }
            var _m1 = this.prod.caf_mat1.filter(x => x.isBase);
            if (_m1.length > 0) {
                this.ps.mat1_id = _m1[0].id;
                this.ps.mat1_color = _m1[0].mat_color;
                this.ps.ins_gold_allowed = _m1[0].ins_gold_allowed;
                this.ps.ins_silver_allowed = _m1[0].ins_silver_allowed;
                this.ps.ins_black_allowed = _m1[0].ins_black_allowed;
                this.ui.linen = s.ui.linen = _m1[0].name.toLowerCase().includes('linen');
            }
            var _m2 = this.prod.caf_mat2.filter(x => x.isBase);
            if (_m2.length > 0) {
                this.ps.mat2_id = _m2[0].id;
                this.ps.mat2_color = _m2[0].mat_color;
            }
            s.ui.product_title = `Custom ${this.prod.DYF_FrameStyleName} Frame`;

            if (s.si.StoreID !== 136072) {
                s.ui.product_title = `Custom ${this.si.ProdInstText} ${this.prod.DYF_FrameStyleName} Frame`;
            }
            s.ui.product_title = s.ui.product_title.replace('Frame Frame', 'Frame');

            s.ui.moulding_has_zoom = true;
            s.ps.DocSizeTierID = 4;
            if (this.prod.DYF_FrameStyleID === 10) {
                this.selected_doc_size = 0;
            }

            // s.prod.allowUpload1 = Portal?.PortalID === 1 && this.prod.DYF_FrameStyleID === 1;
        } else if (this.prod.mats) {
            const mc = this.prod.mats.filter(x => x.id === this.prod.MatComboID)[0];
            if (mc) {
                this.process_color_restrictions_caf();
                this.ps.mat1_color = mc.pmat_color;
                this.ps.ins_gold_allowed = mc.ins_gold_allowed;
                this.ps.ins_silver_allowed = mc.ins_silver_allowed;
                this.ps.ins_black_allowed = mc.ins_black_allowed;
                this.ui.linen = s.ui.linen = mc.pmat_name.toLowerCase().includes('linen');
            }
        }

        this.process_color_restrictions_prod();

        if (this.prod.CustomizationMethod === 1) {
            this.ui.old_style_composite = this.prod.OldCompositeImage;
        }

        // hide year of graduation if linked store, or if diploma not in the product name
        if ((this.si.StoreTypeID === 5 && this.isRetail) || !this.ui.product_title.toLowerCase().includes('diploma') || this.ps.is_caf) {
            this.ui.show_grad_year = false;
        }
        if (this.prod.YearOfGraduation_Required) {
            this.ui.show_grad_year = true;
        }

        this.ui.allow_customer_photos = this.si.allow_customer_photos;
        this.ui.allow_reviews = this.si.allow_reviews;
        if (this.si.StoreID === 205255) {
            this.ui.allow_reviews = false;
        }
        this.ui.allow_smartbox = this.si.allow_smartbox;

        if (Portal?.DisableRealImages) {
            this.ui.allow_customer_photos = false;
        }

        if (Portal?.DisableReviews) {
            this.ui.allow_reviews = false;
        }

        // share
        if (getParameterByName('k')) {
            try {
                let f: ProductStateShare = JSON.parse(atob(getParameterByName('k') as string));
                // console.log(JSON.stringify(f));
                parseInt(f.m0.toString(), 10);
                parseInt(f.m1.toString(), 10);
                parseInt(f.m2.toString(), 10);
                parseInt(f.i.toString(), 10);
                parseInt(f.g.toString(), 10);
                parseInt(f.l.toString(), 10);

                s.ps.moulding_id = f.m0;
                s.ps.mat1_id = f.m1;
                s.ps.mat2_id = f.m2;

                if (f.i > 0) {
                    const m = s.prod.insignias.filter(m => m.id === f.i)[0];
                    if (m) {
                        s.ps.insignia_id = m.id;
                        s.ps.insignia_base_name = m.name;
                        s.ps.insignia_is_dyf = m.isCAF;
                        s.ps.insignia_dyf_color = m.ins_color.toLowerCase();
                        s.ui.name_insignia = m.name.toLowerCase();
                        s.ui.title_insignia = m.title;
                    }
                }

                if (f.l > 0) {
                    const m = s.prod.linos.filter(m => m.id === f.l)[0];
                    if (m) {
                        s.ps.lino_base_name = m.name;
                        s.ps.lino_is_dyf = false;
                        s.ps.lino_id = m.id;
                        s.ps.lino_text = m.name;
                        s.ps.lino_dyf_color = f.lc;
                        s.ps.ep_id = 0;
                    }
                }

                s.ps.glass_id = f.g;
                s.ps.lino_id = f.l;
                s.ps.ep_id = f.e;
                s.ps.ep1 = f.e1;
                s.ps.ep2 = f.e2;
                s.ps.ep3 = f.e3;
                s.ps.ep4 = f.e4;
                s.ps.ep5 = f.e5;
                s.ps.ep6 = f.e6;
                s.ps.ep7 = f.e7;
                s.ps.ep8 = f.e8;
                s.ps.ep9 = f.e9;
                s.ps.ep10 = f.e10;
                s.ps.is_horizontal = f.o;
                s.ps.docWidth = f.w1;
                s.ps.docWidth2 = f.w2;
                s.ps.docHeight = f.h1;
                s.ps.docHeight2 = f.h2;

                // console.log(f);
            } catch (err: any) {
                console.error(err);
            }
        }

        this.ui.doRender = true;
        this.ui.update_pricing = true;

        let clone;
        try {
            clone = structuredClone(this.prod.orig_pcs);
        } catch (e) {
            clone = JSON.parse(JSON.stringify(this.prod.orig_pcs));
        }
        this.pcs = clone;
        this.pcs.ProductTypeID = this.prod.ProductTypeID;

        this.pulse();
        this.ready = true;

        // marketing
        if (this.isRetail && !this.prod.IsCAF) {
            const marketing_item: ga4_item[] = [
                {
                    item_id: s.prod.IsCAF ? `CAF-${s.prod.ProductID}` : s.ps.item_id,
                    item_name: s.prod.Name,
                    coupon: '',
                    currency: 'USD',
                    discount: 0,
                    index: 1,
                    item_brand: __company_name,
                    item_category: s.prod.ProductTypeDisplayName,
                    item_category2: s.si.InstName,
                    location_id: 'ChIJUcHLaPbi54kRtbVMrbSH4MU',
                    price: this.ui.price,
                    quantity: 1,
                    product_id: s.prod.ProductID,
                    item_list_name: s.prod.IsCAF ? `${this.si.InstName}` : this.si.StoreName,
                    item_list_id: this.si.StoreID.toString(),
                    item_variant: this.prod.ItemID,
                },
            ];

            if (marketing_product_visit) {
                marketing_product_visit(marketing_item);
            }
        }

        // window.addEventListener('resize', util.debounce(this.pulse(true), 150));
        window.addEventListener(
            'resize',
            debounce(() => this.pulse(true), 150),
        );

        try {
            let item_image = {
                ProductName: s.prod.Name,
                ProductID: s.prod.ProductID,
                SKU: s.prod.ItemID,
                URL: `https://${window.location.host}${s.si.URL}`,
                Brand: __company_name,
                Price: s.si.Price_Retail,
                ImageUrl: s.prod.CustomizationMethod === 2 ? `https://${Portal?.CDNDomain}/images/products/gen/products/${s.prod.ItemID.toLowerCase()}_${s.prod.ProductID}_1280_1280.png` : `https://${Portal?.CDNDomain}/images/products/full/${s.prod.Image_Full.toLowerCase()}`,
                PortalID: Portal?.PortalID,
            };

            let item_noimage = {
                ProductName: s.prod.Name,
                ProductID: s.prod.ProductID,
                SKU: s.prod.ItemID,
                URL: `https://${window.location.host}${s.si.URL}`,
                Brand: __company_name,
                Price: s.si.Price_Retail,
                PortalID: Portal?.PortalID,
            };

            if (!s.prod.IsCAF && s.prod.CustomizationMethod === 2) {
                klaviyo.push(['track', 'Viewed Product', item_image]);
            } else if (s.prod.IsCAF) {
                klaviyo.push(['track', 'Viewed Product', item_noimage]);
            } else if (s.prod.Image_Full && s.prod.Image_Full.length > 5) {
                klaviyo.push(['track', 'Viewed Product', item_image]);
            } else {
                klaviyo.push(['track', 'Viewed Product', item_noimage]);
            }
            klaviyo.push(['identify', {$lastPortal: Portal?.PortalID}]);
        } catch (errk) {
            console.error(errk);
        }
    };

    @action
    give_ep_color_id = (id: number): number => {
        if (!this.ps.ins_silver_allowed && id === 39) {
            if (this.ps.ins_gold_allowed) {
                return 37;
            } else {
                return 39;
            }
        } else if (!this.ps.ins_gold_allowed && (id === 37 || id < 1)) {
            if (this.ps.ins_silver_allowed) {
                return 39;
            } else {
                return 37;
            }
        } else if (!this.ps.ins_black_allowed && id === 1099) {
            if (this.ps.ins_gold_allowed) {
                return 37;
            } else {
                return 39;
            }
        }
        return id;
    };

    @action
    pulse_fast_ship = (): void => {
        if (!this.__fast_ship_orig || this.prod.IsCAF || !this.isRetail) {
            __fast_ship = false;
            return;
        }

        var diffFromFastShip = false;

        if (s.prod.IsFrame && s.ps.glass_id > 1) {
            diffFromFastShip = true;
        }
        if (s.prod.IsFrame && s.ps.moulding_id !== s.prod.MouldingID) {
            diffFromFastShip = true;
        }
        if (s.prod.IsFrame && s.ps.mat1_id !== s.prod.Mat1_ID) {
            diffFromFastShip = true;
        }
        if (s.prod.IsFrame && s.ps.mat2_id !== s.prod.Mat2_ID) {
            diffFromFastShip = true;
        }
        if (s.prod.IsFrame && s.ps.insignia_id !== s.prod.InsigniaID) {
            diffFromFastShip = true;
        }
        if (s.prod.IsFrame && s.ps.lino_id !== s.prod.LinoID) {
            diffFromFastShip = true;
        }

        if (__fast_ship && diffFromFastShip && !this.__fast_ship_warned) {
            // warn
            this.__fast_ship_warned = true;
            modal('modal-fast-ship-warning');
        }
        __fast_ship = !diffFromFastShip;
    };

    @action
    pulse = (forceRender?: boolean) => {
        // if(!this.ui.msrp || this.ui.msrp < 0){this.ui.msrp = 0;}
        this.pulse_fast_ship();
        if (!this.ps.is_caf) {
            this.pulse_product();
        } else {
            this.pulse_caf();
        }

        // todo i, if invalid insignia or EP elected, switch it to allowed versiin
        // s.ps.ep_id_view === 1099 ? 'black' : s.ps.ep_id_view === 39
        // color enforcement:)
        if (this.prod.IsCAF) {
            this.process_color_restrictions_caf();

            if (this.ps.ep_id > 0) {
                this.ps.ep_id = this.give_ep_color_id(this.ps.ep_id);
            }
            this.ps.ep_id_view = this.give_ep_color_id(this.ps.ep_id_view);

            if (!this.ps.ins_gold_allowed && s.ps.lino_dyf_color === 'gold') {
                if (this.ps.ins_silver_allowed) {
                    s.ps.lino_dyf_color = 'silver';
                }
                if (this.ps.ins_black_allowed) {
                    s.ps.lino_dyf_color = 'black';
                }
            } else if (!this.ps.ins_silver_allowed && s.ps.lino_dyf_color === 'silver') {
                if (this.ps.ins_black_allowed) {
                    s.ps.lino_dyf_color = 'black';
                }
                if (this.ps.ins_gold_allowed) {
                    s.ps.lino_dyf_color = 'gold';
                }
            } else if (!this.ps.ins_black_allowed && s.ps.lino_dyf_color === 'black') {
                if (this.ps.ins_gold_allowed) {
                    s.ps.lino_dyf_color = 'gold';
                }
                if (this.ps.ins_silver_allowed) {
                    s.ps.lino_dyf_color = 'silver';
                }
            }

            if (this.ps.insignia_id > 0) {
                let oldColor = s.ps.insignia_dyf_color;
                let assignedName = '';
                // console.log(oldColor);
                if (!this.ps.ins_gold_allowed && s.ps.insignia_dyf_color === 'gold') {
                    if (this.ps.ins_silver_allowed) {
                        s.ps.insignia_dyf_color = 'silver';
                        if (assignedName === '') {
                            assignedName = 'silver';
                        }
                    }
                    if (this.ps.ins_black_allowed) {
                        s.ps.insignia_dyf_color = 'black';
                        if (assignedName === '') {
                            assignedName = 'black';
                        }
                    }
                } else if (!this.ps.ins_silver_allowed && s.ps.insignia_dyf_color === 'silver') {
                    if (this.ps.ins_black_allowed) {
                        s.ps.insignia_dyf_color = 'black';
                        if (assignedName === '') {
                            assignedName = 'black';
                        }
                    }
                    if (this.ps.ins_gold_allowed) {
                        s.ps.insignia_dyf_color = 'gold';
                        if (assignedName === '') {
                            assignedName = 'gold';
                        }
                    }
                } else if (!this.ps.ins_black_allowed && s.ps.insignia_dyf_color === 'black') {
                    // console.log('black - ');
                    if (this.ps.ins_gold_allowed) {
                        s.ps.insignia_dyf_color = 'gold';
                        if (assignedName === '') {
                            assignedName = 'gold';
                            console.log('gold a - ');
                        }
                    }
                    if (this.ps.ins_silver_allowed) {
                        s.ps.insignia_dyf_color = 'silver';
                        if (assignedName === '') {
                            assignedName = 'silver';
                        }
                    }
                }

                if (assignedName !== '') {
                    let newName = this.ps.insignia_base_name.toLowerCase().replace(oldColor, assignedName);
                    let new_ins = this.prod.insignias.filter(x => x.name.toLowerCase() === newName);

                    if (new_ins && new_ins.length > 0) {
                        this.ps.insignia_id = new_ins[0].id;
                        this.ps.insignia_base_name = new_ins[0].name;
                        this.ps.insignia_is_dyf = new_ins[0].isCAF;
                        this.ui.name_insignia = new_ins[0].name.toLowerCase();
                        this.ui.title_insignia = new_ins[0].title;
                        this.ui.doRender = true;
                    } else {
                        this.ps.insignia_id = -1;
                        this.ui.title_insignia = '';
                        this.ui.doRender = true;
                    }
                }
            }

            if (this.ps.insignia_id > 0 && s.ui.linen && s.ps.insignia_base_name.toLowerCase().includes('embossed')) {
                this.ps.insignia_id = -1;
                this.ui.title_insignia = '';
                this.ui.doRender = true;
            }
        }

        this.process_color_restrictions_prod();

        if (this.ui.doRender || forceRender) {
            prerender_set_pcs();
            this.ps.css = r.render(this.pcs, RenderType.Normal);
            this.glass_update();
            this.setUI();

            if (this.RenderingV2) {
                this.frameV2 = r.renderV2(this.pcs, RenderType.Normal);
            }
        }
        if (this.ui.update_pricing) {
            this.ui.update_pricing = false;
            pricing();
        }
        if (this.ui.update_doc_sizes) {
            updateShippingBoxID();
        }

        this.ui.show_atc = true;
        this.ui.is_bo = false;
        this.ui.bo_msg = '';
        if (this.si.StoreTypeID === 5 && this.isRetail) {
            this.ui.show_atc = false;
            this.ui.show_pricing = false;
        } else if (this.isRetail && this.prod && this.prod.BO_Single) {
            this.ui.show_atc = false;
            this.ui.is_bo = true;
            this.ui.bo_msg = s.prod.BO_OverrideText;
        } else if ((this.isRetail || this.prod.IsBO_MyFrames) && this.prod.BO_Text !== '' && this.prod.BO_FramePartID === this.ps.moulding_id) {
            this.ui.show_atc = false;
            this.ui.is_bo = true;
            this.ui.bo_msg = s.prod.BO_Text;
        } else if (!this.isRetail && this.prod.BO_MyFramesText !== '') {
            this.ui.show_atc = false;
            this.ui.is_bo = true;
            this.ui.bo_msg = this.prod.BO_MyFramesText;
        }
    };

    @action
    getPPIValuesForImageUpload = () => {
        const _uploadCheck_W = !this.prod.docWidth || this.prod.docWidth < 1 ? this.ps.docWidth : this.prod.docWidth;
        const _uploadCheck_H = !this.prod.docHeight || this.prod.docHeight < 1 ? this.ps.docHeight : this.prod.docHeight;

        if (this.prod && _uploadCheck_W > 0) {
            this.ppi_w = _uploadCheck_W * 150;
            this.ppi_h = _uploadCheck_H * 150;
            this.ppi_w_max = _uploadCheck_W * 300;
            this.ppi_h_max = _uploadCheck_H * 300;
        }
    };

    @action
    pulse_product = () => {
        this.ui.sku = this.ui.item_id === this.ps.base_item_id ? this.si.SKU : '';
        this.ui.item_id = `${this.ps.customized_core ? 'C' : ''}${this.ps.customized_glass ? 'G' : ''}${this.ps.base_item_id}`;
        this.ps.DocSizeTierID = r.Get_DocumentSizeTierID(this.ps.docWidth, this.ps.docHeight, this.prod.ProductTypeID);

        // if(this.ui.mat_change){
        //     this.ui.mat_change = false;
        //     const m = s.prod.mats.filter(m => m.id === this.ps.matcombo_id)[0];
        //     this.ps.css.pmat_BackgroundImage = this.ps.css.pmat_BackgroundImage.replace(/(v2\/)(.*)(_)/g, `v2/${m.pmat_name.toLowerCase()}_`);

        //     const isFillet = (m.mat2_id === 36 || m.mat1_id === 38);
        //     this.ps.css.fillet_visible = isFillet;
        //     const smat = `#${m.smat_color}`;
        //     this.ps.css.doc1_smat_backgroundColor = smat;
        //     this.ps.css.doc2_smat_backgroundColor = smat;
        //     this.ps.css.tassel_smat_backgroundColor = smat;
        //     this.ps.css.varsity_smat_backgroundColor = smat;
        //     this.ps.css.oval_smat_backgroundColor = smat;
        //     this.ps.css.spirit_smat_bg = smat;

        //     if(isFillet){

        //     } else {

        //     }
        // }

        // this.ui.price = this.isRetail ? this.si.price_Retail : this.si.price_Wholesale;
    };

    @action
    pulse_caf = () => {
        this.ps.DocSizeTierID = r.Get_DocumentSizeTierID(this.ps.docWidth, this.ps.docHeight, this.prod.ProductTypeID);
    };

    @action
    glass_update = () => {
        for (let i = 0; i < this.glass.length; i++) {
            this.glass[i].price = currency_noNegatives(this.getGlassPrice(this.prod.orig_pcs, s.ps.DocSizeTierID, this.glass[i].id)).replace('.00', '');
        }
    };

    @action
    process_color_restrictions_caf = () => {
        if (!this.prod.IsCAF) {
            return;
        }
        const mat = s.prod.caf_mat1.filter(x => x.id === s.ps.mat1_id)[0];
        const m = s.prod.mouldings.filter(x => x.id === s.ps.moulding_id)[0];
        // console.log(m.dyf_color);
        if (mat && m) {
            this.ps.ins_gold_allowed = mat.ins_gold_allowed && m.dyf_color !== 'no gold';
            this.ps.ins_silver_allowed = mat.ins_silver_allowed && m.dyf_color !== 'no silver';
            this.ps.ins_black_allowed = mat.ins_black_allowed && m.dyf_color !== 'no black';
        }
    };

    @action
    process_color_restrictions_prod = () => {
        if (this.prod.IsCAF) {
            return;
        }

        const lino = s.prod.linos.find(i => i.id === s.ps.lino_id);
        const mat = s.prod.mats.find(i => i.id === s.ps.matcombo_id);

        if (lino && mat) {
            const ifLinoIsNot = (color: string) => lino.desc4 !== color && !lino.name.toLowerCase().includes(color);

            this.ps.ins_silver_allowed = ifLinoIsNot('gold') && mat.ins_silver_allowed;
            this.ps.ins_gold_allowed = ifLinoIsNot('silver') && mat.ins_gold_allowed;
        }
    };

    @action
    setUI = () => {
        const moulding = s.prod.mouldings.filter(m => m.id === s.ps.moulding_id)[0];

        const _glass = s.glass.filter(m => m.id === this.ps.glass_id)[0];

        if (moulding) {
            this.ui.name_moulding = moulding.name.toLowerCase();
            this.ui.title_moulding = moulding.title;

            this.ui.moulding_has_zoom = moulding.has_zoom;
            this.ui.moulding_zoom_path = moulding.IMG_Zoom;
            this.ui.moulding_zoom_path_th = moulding.IMG_Zoom_Thumb;
        }
        if (this.ps.is_caf) {
            this.ui.moulding_has_zoom = true;
        }

        if (!this.ps.is_caf) {
            const mat = s.prod.mats.filter(m => m.id === s.ps.matcombo_id)[0];
            if (mat) {
                this.ui.name_mat1 = mat.pmat_name.toLowerCase();
                this.ui.name_mat2 = mat.smat_name.toLowerCase();

                this.ui.title_mat_combo = mat.title;
                this.ui.title_mat1 = mat.pmat_title;
                this.ui.title_mat2 = mat.smat_title;

                this.ui.color_mat1 = mat.pmat_color;
                this.ui.color_mat2 = mat.smat_color;
            }
        } else {
            const m1 = s.prod.caf_mat1.filter(m => m.id === s.ps.mat1_id)[0];
            const m2 = s.prod.caf_mat2.filter(m => m.id === s.ps.mat2_id)[0];
            if (m1) {
                this.ui.name_mat1 = m1.name.toLowerCase();
                this.ui.title_mat1 = m1.title;
                this.ui.color_mat1 = m1.mat_color;
            }
            if (m2) {
                this.ui.name_mat2 = m2.name.toLowerCase();
                this.ui.title_mat2 = m2.title;
                this.ui.color_mat2 = m2.mat_color;
            }
        }

        if (_glass) {
            this.ui.name_glass = _glass.title;
        }
    };

    blankFunction = () => {
        const x = 1;
    };

    closeTooltips = () => {
        setTimeout(function () {}, 1500);
    };

    @action
    share = async (): Promise<void> => {
        const ps: ProductStateShare = {
            m0: s.ps.moulding_id,
            m1: s.ps.mat1_id,
            m2: s.ps.mat2_id,
            i: s.ps.insignia_id,
            g: s.ps.glass_id,
            l: s.ps.lino_id,
            e: s.ps.ep_id,
            e1: s.ps.ep1,
            e2: s.ps.ep2,
            e3: s.ps.ep3,
            e4: s.ps.ep4,
            e5: s.ps.ep5,
            e6: s.ps.ep6,
            e7: s.ps.ep7,
            e8: s.ps.ep8,
            e9: s.ps.ep9,
            e10: s.ps.ep10,
            o: s.ps.is_horizontal,
            w1: s.ps.docWidth,
            w2: s.ps.docWidth2,
            h1: s.ps.docHeight,
            h2: s.ps.docHeight2,
            lc: s.ps.lino_dyf_color,
        };

        const shareData = {
            title: `${s.si.InstName} ${s.ui.product_title}`,
            text: `Shared with you: ${s.si.InstName} ${s.ui.product_title} via diaplomaframe.com`,
            url: `${window.location.href}?k=${btoa(JSON.stringify(toJS(ps)))}`,
        };

        try {
            window.dataLayer.push({
                event: 'share',
                event_params: {
                    item_id: s.ps.base_item_id,
                    method: 'product-page',
                    content_type: 'product',
                },
            });
        } catch (err) {
            console.error(err);
        }

        // console.log(JSON.stringify(toJS(ps)).length);
        // console.log(encodeURIComponent(JSON.stringify(toJS(ps))).length);
        // console.log(shareData.url.length);
        try {
            await navigator.share(shareData);
        } catch (err) {
            console.error(err);
        }
    };

    @action
    getGlassPrice = (pcs: ProductCustomizationState, DocSizeTierID: number, GlassID: number): number => {
        const photo_frames = [10, 50, 56, 57, 58, 59, 60];
        const isPhotoFrame = photo_frames.includes(pcs.ProductTypeID);
        let Glass_DocSizeTierID = -0;

        if (isPhotoFrame) {
            if (DocSizeTierID === 1) {
                Glass_DocSizeTierID = 1;
            } else if (DocSizeTierID === 14) {
                Glass_DocSizeTierID = 14;
            } else if (DocSizeTierID === 2 || DocSizeTierID === 13) {
                Glass_DocSizeTierID = 2;
            } else if (DocSizeTierID >= 3 && DocSizeTierID <= 5) {
                Glass_DocSizeTierID = 5;
            } else {
                Glass_DocSizeTierID = 8;
            }
        } else {
            if (DocSizeTierID < 3 || DocSizeTierID === 13) {
                Glass_DocSizeTierID = 2;
            } else if (DocSizeTierID === 14) {
                Glass_DocSizeTierID = 14;
            } else if (DocSizeTierID >= 3 && DocSizeTierID <= 5) {
                Glass_DocSizeTierID = 5;
            } else {
                Glass_DocSizeTierID = 8;
            }
        }

        const isOversized: boolean = __oversized.includes(pcs.ProductTypeID);
        // console.log('isOversized', isOversized);

        if (isOversized) {
            if (Glass_DocSizeTierID === 14) {
                Glass_DocSizeTierID = 2;
            } else if (Glass_DocSizeTierID === 2) {
                Glass_DocSizeTierID = 5;
            } else if (Glass_DocSizeTierID === 5) {
                Glass_DocSizeTierID = 8;
            }
        }

        // console.log('Glass_DocSizeTierID', Glass_DocSizeTierID);

        let price: number = 0;
        if (!s.isRetail) {
            price = s.glass_prices.filter(x => x.GlassID === GlassID && x.DocumentSizeTierID === Glass_DocSizeTierID)[0].Price_Wholesale;
        } else {
            price = s.glass_prices.filter(x => x.GlassID === GlassID && x.DocumentSizeTierID === Glass_DocSizeTierID)[0].Price;
        }

        if (isOversized && GlassID !== 1) {
            price += 10;
        }

        return price;
    };

    // getReplaceImage = () => {
    //     const th6Enabled = !this.prod.th6Disabled && !isNullOrWhiteSpace(this.prod.th6);
    //
    //     if (th6Enabled) {
    //         const defaultConfiguration =
    //             this.prod.MouldingID === this.pcs.MouldingID && this.prod.Mat1_ID === this.pcs.mat1_id && this.prod.Mat2_ID === this.pcs.mat2_id && this.prod.InsigniaID === this.pcs.insignia_id && this.prod.EngravedPlateStatusID === this.pcs.ep_id && this.prod.LinoID === this.pcs.lino_id;
    //
    //         this.replaceImage = defaultConfiguration && th6Enabled && AbTestStore.ABIsVariant(ABTestKeys.ab_prod_th6, 1);
    //     }
    // };
}

const s = new ProdStore();

export default s;
